var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import query from "syf-component-library/const/mediaQueries";
import { spacing } from "syf-component-library/defaultTheme";
import { Select } from "syf-component-library/ui/atoms";
import { FAS_CARET_DOWN, FAS_CARET_UP } from "../../../../../const/icons";
import { sortByAmount, sortByDate, sortByStatus, } from "../../../../../helpers/certificateHistoryUtils";
var SelectWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 375px;\n  width: 100%;\n  padding: ", "px ", "px ", "px;\n\n  @media ", " {\n    margin: 0 auto;\n    width: 90%;\n  }\n"], ["\n  max-width: 375px;\n  width: 100%;\n  padding: ", "px ", "px ", "px;\n\n  @media ", " {\n    margin: 0 auto;\n    width: 90%;\n  }\n"])), spacing.base, spacing.base, spacing.base, query.lessThanMedium);
var SelectDropdown = function (_a) {
    var certificateDetails = _a.certificateDetails, setSortSelection = _a.setSortSelection, onSelectOptionClick = _a.onSelectOptionClick;
    var t = useTranslation().t;
    var _b = useState("newDate"), selectedOption = _b[0], setSelectedOption = _b[1];
    var newDateLabel = t("selectDropdown.newestDate");
    var oldDateLabel = t("selectDropdown.oldestDate");
    var redeemStatusLabel = t("selectDropdown.redeemedStatus");
    var expiredStatusLabel = t("selectDropdown.expiredStatus");
    var lowestAmountLabel = t("selectDropdown.lowestAmount");
    var highestAmountLabel = t("selectDropdown.highestAmount");
    var allOptions = useMemo(function () {
        return [
            {
                label: newDateLabel,
                value: "newDate",
                onClick: function () {
                    setSortSelection({ sortFunction: sortByDate, direction: "desc" });
                },
            },
            {
                label: oldDateLabel,
                value: "oldDate",
                onClick: function () {
                    setSortSelection({ sortFunction: sortByDate, direction: "asc" });
                },
            },
            {
                label: redeemStatusLabel,
                value: "redeemedStatus",
                onClick: function () {
                    setSortSelection({ sortFunction: sortByStatus, direction: "asc" });
                },
            },
            {
                label: expiredStatusLabel,
                value: "expiredStatus",
                onClick: function () {
                    setSortSelection({ sortFunction: sortByStatus, direction: "desc" });
                },
            },
            {
                label: lowestAmountLabel,
                value: "lowestAmount",
                onClick: function () {
                    setSortSelection({ sortFunction: sortByAmount, direction: "asc" });
                },
            },
            {
                label: highestAmountLabel,
                value: "highestAmount",
                onClick: function () {
                    setSortSelection({ sortFunction: sortByAmount, direction: "desc" });
                },
            },
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newDateLabel,
        oldDateLabel,
        redeemStatusLabel,
        expiredStatusLabel,
        lowestAmountLabel,
        highestAmountLabel,
    ]);
    var getDefaultOption = function (dropOptions, option) {
        return dropOptions.find(function (_a) {
            var value = _a.value;
            return value === option;
        });
    };
    return (_jsx(SelectWrapper, __assign({ "data-cy": "select-sorting-wrapper" }, { children: _jsx(Select, { name: "sortable-select", placeholder: t("selectDropdown.sortBy"), id: "sort-select", onChange: function (selected) {
                setSelectedOption(selected.value);
                onSelectOptionClick(certificateDetails);
            }, defaultOption: getDefaultOption(allOptions, selectedOption), isDisabled: !certificateDetails.length, options: allOptions, rightIconClosed: _jsx(FontAwesomeIcon, { icon: FAS_CARET_DOWN, size: "sm" }), rightIconOpen: _jsx(FontAwesomeIcon, { icon: FAS_CARET_UP, size: "sm" }) }) })));
};
export default SelectDropdown;
var templateObject_1;
